// Per-locality SEO content for landing pages: /areas/:slug
export const LOCALITIES = [
  {
    slug: "gachibowli",
    name: "Gachibowli",
    headline: "Invisible Grills in Gachibowli",
    intro:
      "Gachibowli's skyline of high-rise apartments and gated communities demands balcony safety that never blocks the view. We install near-invisible SS304 & SS316 steel-cable grills across Gachibowli towers — child & pet safe, rust-free, and completely transparent.",
    landmarks: ["DLF Cyber City", "Aparna Sarovar", "My Home Avatar", "IIIT Hyderabad", "Lanco Hills"],
    nearby: ["kondapur", "financial-district", "nanakramguda", "manikonda"],
  },
  {
    slug: "kondapur",
    name: "Kondapur",
    headline: "Invisible Grills in Kondapur",
    intro:
      "From Botanical Garden Road to Kothaguda, Kondapur homes rely on our invisible grills for balcony and window safety without losing an inch of natural light or ventilation. Premium tension cabling, neat finishing, and a written warranty.",
    landmarks: ["Botanical Garden", "Kothaguda Junction", "Sarath City Capital Mall", "Harsha Toyota"],
    nearby: ["gachibowli", "madhapur", "hitech-city", "miyapur"],
  },
  {
    slug: "madhapur",
    name: "Madhapur",
    headline: "Invisible Grills in Madhapur",
    intro:
      "Madhapur and the surrounding IT hub host thousands of apartments where families want safety that respects the view. Our invisible grills keep children and pets secure while your balcony stays open and airy.",
    landmarks: ["HITEC City", "Inorbit Mall", "Durgam Cheruvu", "Ayyappa Society"],
    nearby: ["hitech-city", "kondapur", "gachibowli"],
  },
  {
    slug: "hitech-city",
    name: "Hitech City",
    headline: "Invisible Grills in Hitech City",
    intro:
      "High-rise living in Hitech City needs high-tension safety. We fit marine-grade SS316 invisible grills engineered for tall towers and open, windy balconies — protection you barely notice against the skyline.",
    landmarks: ["Cyber Towers", "Mindspace", "Durgam Cheruvu Cable Bridge", "Raheja Mindspace"],
    nearby: ["madhapur", "kondapur", "gachibowli"],
  },
  {
    slug: "kukatpally",
    name: "Kukatpally",
    headline: "Invisible Grills in Kukatpally",
    intro:
      "KPHB and Kukatpally's dense residential towers trust us for clean, strong invisible grill installations. Ideal for families in high-floor apartments who want an unobstructed view and total peace of mind.",
    landmarks: ["KPHB Colony", "Forum Sujana Mall", "JNTU", "Manjeera Mall"],
    nearby: ["miyapur", "nizampet", "bachupally"],
  },
  {
    slug: "manikonda",
    name: "Manikonda",
    headline: "Invisible Grills in Manikonda",
    intro:
      "Manikonda and Puppalaguda apartments choose our invisible grills for safe balconies that keep the breeze flowing. Fast measurement, tidy installation, and long-lasting rust-free steel.",
    landmarks: ["Lanco Hills", "OU Colony", "Alkapuri", "Puppalaguda"],
    nearby: ["gachibowli", "financial-district", "nanakramguda"],
  },
  {
    slug: "financial-district",
    name: "Financial District",
    headline: "Invisible Grills in Financial District",
    intro:
      "The premium towers of Financial District and Nanakramguda deserve premium safety. Our SS316 invisible grills are built for tall, exposed balconies — corrosion-resistant, high-tension, and virtually invisible.",
    landmarks: ["Wipro Circle", "My Home Bhooja", "ICICI Towers", "Nanakramguda"],
    nearby: ["gachibowli", "nanakramguda", "kokapet"],
  },
  {
    slug: "nanakramguda",
    name: "Nanakramguda",
    headline: "Invisible Grills in Nanakramguda",
    intro:
      "Nanakramguda's growing skyline of gated communities relies on our invisible grills for child and pet safety across high floors — installed by our own trained crew with a written warranty.",
    landmarks: ["TSPA Junction", "Vasavi Skyla", "Financial District", "Aparna Cyberzon"],
    nearby: ["financial-district", "gachibowli", "kokapet"],
  },
  {
    slug: "miyapur",
    name: "Miyapur",
    headline: "Invisible Grills in Miyapur",
    intro:
      "Miyapur homes along the metro corridor pick our invisible grills for reliable balcony and window safety. Strong, transparent steel cabling that keeps your view — and your family — protected.",
    landmarks: ["Miyapur Metro", "Alwyn Colony", "Chandanagar", "Bachupally Road"],
    nearby: ["kukatpally", "nizampet", "bachupally"],
  },
  {
    slug: "kokapet",
    name: "Kokapet",
    headline: "Invisible Grills in Kokapet",
    intro:
      "Kokapet and Neopolis luxury high-rises demand a flawless finish. Our invisible grills deliver architectural-grade safety with marine SS316 cabling that vanishes against the view.",
    landmarks: ["Neopolis", "Kokapet SEZ", "My Home Apas", "Rajapushpa Provincia"],
    nearby: ["financial-district", "nanakramguda", "gachibowli"],
  },
];

export const localityBySlug = (slug) => LOCALITIES.find((l) => l.slug === slug);
